export const getToken = () => {
  // Check localStorage first
  const localStorageToken = localStorage.getItem('token');
  if (localStorageToken) return localStorageToken;

  // Then check cookies
  const cookieToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('token='))
    ?.split('=')[1];
  
  return cookieToken || null;
};

export const getCurrentUser = () => {
  const token = getToken();
  if (!token) return null;

  try {
    // Extract payload part of JWT
    const payload = token.split('.')[1];
    if (!payload) return null;

    // Base64 decode and parse
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const userData = JSON.parse(decodedPayload);

    return {
      email: userData.email,
      name: userData.name || '',
      role: userData.role || 'user'
    };
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};